import { NgForOf } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { YoungAdultsPriceList } from '../../models';
import { CompanyEnum } from '../../models/company.model';
import { GeneralFeeTableComponent } from '../general-fee-table/general-fee-table.component';
import { CampsCourseTableComponent } from '../camps-course-table/camps-course-table.component';
import { CampsTransfersTableComponent } from '../camps-transfers-table/camps-transfers-table.component';
import { YoungAdultsHeaderComponent } from '../young-adults-header/young-adults-header.component';
import { YoungAdultsPrivateLessonsTableComponent } from '../young-adults-private-lessons-table/young-adults-private-lessons-table.component';
import { CampDatesComponent } from '../camp-dates/camp-dates.component';
import { PriceListNoteApiDto } from '@lx/shared/api';
import SubjectEnum = PriceListNoteApiDto.SubjectEnum;
import { ApplicationFormService } from '../../services/application-form.service';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-young-adults-price-list-data',
  imports: [
    CampsCourseTableComponent,
    CampsTransfersTableComponent,
    GeneralFeeTableComponent,
    NgForOf,
    YoungAdultsHeaderComponent,
    YoungAdultsPrivateLessonsTableComponent,
    YoungAdultsPrivateLessonsTableComponent,
    CampDatesComponent,
  ],
  templateUrl: './young-adults-price-list-data.component.html',
  styleUrls: ['./young-adults-price-list-data.component.scss'],
})
export class YoungAdultsPriceListDataComponent implements OnInit {
  @Input() schools: YoungAdultsPriceList[] | undefined;

  endDatesFlag = SubjectEnum.YOUNG_ADULTS_START_END_DATES;
  youngAdultsCoursesSubject = SubjectEnum.YOUNG_ADULTS_COURSES;
  youngAdultsTransfersSubject = SubjectEnum.YOUNG_ADULTS_TRANSFERS;
  applicationForms = [];
  protected company = CompanyEnum.KIL;

  private readonly applicationFormService = inject(ApplicationFormService);

  ngOnInit(): void {
    this.applicationForms = this.applicationFormService.getYoungAdultsApplicationForm();
  }
}
